import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/login', component: () => import('../views/Login.vue'), meta: { noAuth: true } },
    { path: '/', redirect: '/dashboard' },
    { path: '/dashboard', component: () => import('../views/Dashboard.vue') },
    { path: '/users', component: () => import('../views/Users.vue') },
    { path: '/rooms', component: () => import('../views/Rooms.vue') },
    { path: '/guilds', component: () => import('../views/Guilds.vue') },
    { path: '/mall', component: () => import('../views/Mall.vue') },
    { path: '/decorations', component: () => import('../views/Decorations.vue') },
    { path: '/gifts', component: () => import('../views/Gifts.vue') },
    { path: '/vip', component: () => import('../views/Vip.vue') },
    { path: '/recharge', component: () => import('../views/Recharge.vue') },
    { path: '/rank', component: () => import('../views/Rank.vue') },
    { path: '/withdraw', component: () => import('../views/WithdrawLogs.vue') },
    { path: '/finance', component: () => import('../views/FinanceReport.vue') },
    { path: '/organizations', component: () => import('../views/Organizations.vue') },
    { path: '/org-rewards', component: () => import('../views/OrgRewards.vue') },
    { path: '/org-reward-logs', component: () => import('../views/OrgRewardLogs.vue') },
    { path: '/settings/basic', component: () => import('../views/SettingsBasic.vue') },
    { path: '/settings/exchange', component: () => import('../views/SettingsExchange.vue') },
    { path: '/settings/agreements', component: () => import('../views/SettingsAgreements.vue') },
    { path: '/settings/payment', component: () => import('../views/SettingsPayment.vue') },
  ],
})

// 路由守卫：未登录跳转到登录页
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  if (to.meta.noAuth) {
    next()
  } else if (!token) {
    next('/login')
  } else {
    next()
  }
})

export default router
